export default {
  colors: {
    main: `#003893`,
    purple: `#3e1c91`,
    blue: `#0d7fe9`,
    lightBlue: `#edf6fe`,
    mint: `#05a7cf`,
    lightMint: `#99e9ec`,
    error: `#c11a00`,
    success: ` #01ab33`,
    text: `#222`,
    subText: `#888`,
    border: `#eaeaea`,
    background: ` #f6fbff`,
    white: `#fff`,
    black: `#000`,
  },

  size: {
    minWidth: `980px`,
    maxWidth: `1180px`,
  },
};
